import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
  ToastController,
  Platform,
  PopoverController,
  AlertController,
} from "ionic-angular";
import { Keychain } from "@ionic-native/keychain";
import { MarketPlaceInfoPage } from "../../pages/market-place-info/market-place-info";

declare var cordova: any;

@Injectable()
export class ApplicationApiProvider {
  constructor(
    public http: HttpClient,
    private toast: ToastController,
    private keychain: Keychain,
    private platform: Platform,
    private popoverCtrl: PopoverController
  ) {}

  isNative(): boolean {
    let exactPlatform =
      this.platform.platforms()[this.platform.platforms().length - 1];
    if (
      exactPlatform == "android" ||
      exactPlatform == "iphone" ||
      exactPlatform == "tablet"
    ) {
      return true;
    } else {
      return false;
    }
  }

  isIPhone(): boolean {
    let exactPlatform =
      this.platform.platforms()[this.platform.platforms().length - 1];

    if (exactPlatform == "iphone") {
      return true;
    } else {
      return false;
    }
  }
  isDev(): boolean {
    return (
      location.host === "localhost:8100" ||
      location.hostname === "http://localhost:8100"
    );
  }

  showToast(message: string): void {
    this.toast
      .create({
        message: message,
        duration: 2000,
      })
      .present();
  }

  createAuthBrowser(callback: Function): void {
    let _this = this;
    let interval;
    let options = "clearcache=yes,location=yes";

    // used to avoif caching
    let inAppBrowserRef = cordova.InAppBrowser.open(
      `https://sta-rms.siemens-energy.com/myhealth/assets/auth/webtoken.html?&timestamp=${Date.now()}`,
      "_blank",
      options
    );
    inAppBrowserRef.addEventListener("loadstop", function (event) {
      /**
       * Detect when inappbrowser loads the successful auth page
       * Inject a script which reads the token from the inapp browser
       */
      if (
        event.url.includes(
          `https://sta-rms.siemens-energy.com/myhealth/assets/auth/webtoken.html#`
        )
      ) {
        // Check the localstorage each 1000 ms and extract the token
        interval = setInterval(() => {
          // Inject a script in the inappbrowser wich will expose the token
          inAppBrowserRef.executeScript(
            {
              code: `
            var token =  localStorage.getItem("token");
            localStorage.clear();
            token;
            `,
            },
            function (values) {
              if (values[0]) {
                // If we are on ios we will store the token in the keychain
                if (_this.platform.is("ios")) {
                  _this.keychain
                    .set("token", values[0], false)
                    .then(() => {
                      inAppBrowserRef.close();
                      callback();
                    })
                    .catch(() => {});
                } else {
                  localStorage.setItem("token", values[0]);
                  inAppBrowserRef.close();
                  callback();
                }
              }
            }
          );
        }, 1000);
      }
    });

    inAppBrowserRef.addEventListener("exit", () => {
      // Login is complete we can redirect the app
      (<any>window).cookieMaster.clear(
        function () {
          console.log("Cookies have been cleared");
        },
        function () {
          console.log("Cookies could not be cleared");
        }
      );
      clearInterval(interval);
    });
  }

  detectOs(): string {
    let OSName = "Unknown OS";
    if (navigator.userAgent.indexOf("Win") !== -1) {
      OSName = "Windows";
    }
    if (navigator.userAgent.indexOf("Mac") !== -1) {
      OSName = "Macintosh";
    }
    if (navigator.userAgent.indexOf("Linux") !== -1) {
      OSName = "Linux";
    }
    if (navigator.userAgent.indexOf("Android") !== -1) {
      OSName = "Android";
    }
    if (navigator.userAgent.indexOf("like Mac") !== -1) {
      OSName = "iOS";
    }
    return OSName;
  }

  presentMarketPlaceInfo() {
    const osName = this.detectOs();
    if (!this.isNative() && (osName === "Android" || osName === "iOS")) {
      const marketPlacePopover = this.popoverCtrl.create(MarketPlaceInfoPage, {
        osName: osName,
      });
      marketPlacePopover.present();
    }
  }

  getCopyrightText() {
    return `Siemens ${new Date().getFullYear().toString()}`;
  }
}



// WEBPACK FOOTER //
// ./src/providers/application-api/application-api.ts